import { render, staticRenderFns } from "./PrevNext.vue?vue&type=template&id=50a90e50"
import script from "./PrevNext.vue?vue&type=script&lang=js"
export * from "./PrevNext.vue?vue&type=script&lang=js"
import style0 from "./PrevNext.vue?vue&type=style&index=0&id=50a90e50&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports